import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'providers/AuthProvider'
import apiClient, { handleAPIError } from 'helpers/apiService';
import classNames from 'classnames';

import imageIcon from 'assets/img/th-each-ai/image-placeholder.webp';

import Button from 'components/base/Button';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Blog } from 'pages/community/components/DataDefinitions';

interface MagazinePreviewProps {
    className?: string;
}

const MagazinePreview: React.FC<MagazinePreviewProps> = ({ className }) => {


    const auth = useAuth();
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const [blog, setBlog] = useState<Blog>();

    const truncateText = (longText: string, maxLength: number = 100) => {
        const truncatedText =
            longText.length > maxLength ? longText.slice(0, maxLength) + '...' : longText;
        return truncatedText;

    };

    const fetchData = async () => {
        try {
            const { data } = await apiClient.get('/v1/latest-blog');
            setBlog(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);



    if (loading || blog == null) {
        return <div>Loading...</div>;
    }

    return (
        <Card className={classNames(className, "h-100")} style={{ maxHeight: '40vh' }} >
            <Row className="h-100">
                <Col md={7} className="d-flex align-items-stretch">
                    <div
                        className="p-4 rounded-start w-100"
                        style={{
                            backgroundImage: blog.picture
                                ? `url("data:image/jpeg;base64, ${blog.picture}")`
                                : imageIcon,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            height: '100%',
                        }}
                    />
                </Col>
                <Col md={5} className="d-flex flex-column">
                    <Card.Body className="overflow-auto">
                        <Card.Title as="h3">Magazine</Card.Title>
                        <Card.Title as="h4">{blog.title}</Card.Title>
                        <Card.Text>
                            {truncateText(blog.description, 150)}
                        </Card.Text>
                        <Card.Text>
                            <small className="text-muted">Created on {blog.inserted_at}</small>
                        </Card.Text>
                        <Button
                            variant="primary"
                            onClick={() => window.open(blog.url, '_blank')}
                        >
                            {t('Blogs.visit_url')}
                            <FontAwesomeIcon icon={faExternalLink} className="px-1 fs-10" />
                        </Button>
                    </Card.Body>
                </Col>
            </Row>
        </Card>

    );
};


export default MagazinePreview;